import { Link } from 'react-router-dom'
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { LogOut, Menu, User } from 'lucide-react';
import { useState } from 'react';
import { CurtinLogo } from '../images/curtin-logo';
import { useHeaderStore } from '../store/header-store';
// import { userSessionProvider } from '../../providers/user-session-provider';
// import { hasAdminGroup } from '../../utils/user-utils';

export type NavLink = {
  name: string;
  url: string;
};

export type HeaderProps = {
  navLinks: Array<NavLink>;
  userName: string;
  signOutFromAD: () => void;
};

export default function Header(props: HeaderProps) {
  const headerState = useHeaderStore((h) => h.headerState);
  const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  // const [showAdmin, setShowAdmin] = useState<boolean>(false);

  const { navLinks, userName, signOutFromAD } = props;

  const profileMenu = () => {
    return (
      <DropdownMenu open={isProfileOpen} onOpenChange={setIsProfileOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="h-8 w-8 rounded-full border border-curtin-secondary-black-100/70 bg-transparent text-curtin-secondary-black-100/70 hover:bg-curtin-secondary-gray-07 cursor-pointer [&_svg]:size-4"
            aria-label="Menu"
          >
            <User className="h-4 w-4" />
            <span className="sr-only">User menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-[165px] rounded-2xl text-[14px] font-semibold shadow-[0px_4px_24.1px_0px_rgba(0,0,0,0.1)]"
        >
          {/* {showAdmin && (
            <DropdownMenuItem asChild>
              <Link to="/admin" className="flex gap-5">
                <Settings />
                Assistant studio
              </Link>
            </DropdownMenuItem>
          )} */}
          <DropdownMenuItem asChild className="bg-white/100">
            <Link to="#" onClick={signOutFromAD} className="flex gap-5">
              <LogOut />
              Sign out
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  return (
    <header className='sticky top-0 z-50 border-b border-grey-300 bg-white px-5'>
      <div className='flex min-h-20 items-center justify-between space-x-6'>
        <Link to='https://curtin.edu.au' className='flex items-center gap-2'>
          <div className=''>
            <CurtinLogo />
          </div>
        </Link>
        <nav className='hidden items-center gap-10 xl:flex xl:grow xl:justify-end'>
          {navLinks.map((link) => (
            <Link
              to={link.url}
              key={link.name}
              className='flex h-20 items-center font-proxima-nova text-base font-semibold leading-6 text-curtin-secondary-black-100/70 duration-300 hover:border-b-4 hover:border-curtin-purple hover:pt-1 hover:text-curtin-purple hover:transition-all hover:cursor-pointer'
              target='_blank'>
              <span>{link.name}</span>
            </Link>
          ))}
        </nav>

        {
          headerState.showHeaderMenu && (
          <div className='flex grow items-center justify-end gap-2 space-x-2 pl-8 xl:grow-0'>
            <span className='hidden justify-self-end font-proxima-nova text-base font-semibold leading-6 text-curtin-secondary-black-100/70 xl:flex'>{userName}</span>
            {profileMenu()}
          </div>
          )
        }

        <div className='xl:hidden'>
          <DropdownMenu open={isNavMenuOpen} onOpenChange={setIsNavMenuOpen}>
            <DropdownMenuTrigger asChild>
              <Button variant='ghost' className='h-12 w-12 [&_svg]:size-8 hover:cursor-pointer' aria-label='Menu'>
                <Menu />
                <span className='sr-only'>Navigation menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align='end' className='w-56 bg-white'>
              {navLinks.map((link) => (
                <DropdownMenuItem asChild key={link.name}>
                  <Link to={link.url} className='cursor-pointer'>
                    {link.name}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  )
}
